import { memo } from 'react';
import { Flex } from '@bridebook/aura';
import { useIsAuthenticated } from '@bridebook/web/lib/auth/hooks/use-is-authenticated';
import { useTranslation } from 'next-i18next';
import { NWS_IMAGE } from './constants';
import NWSDiscountCardLocked from './NWSDiscountCardLocked';
import NWSDiscountCardUnlocked from './NWSDiscountCardUnlocked';

const NWSDiscountCard = () => {
  const { t } = useTranslation('articles');
  const { isAuthenticated } = useIsAuthenticated();

  return (
    <section className="overflow-hidden rounded-3xl border border-indigo-crush-20 bg-white text-space">
      <img
        src={NWS_IMAGE}
        alt={t('nwsDiscountCard.imageAlt')}
        className="!mb-0 block !h-[150px] w-full object-cover"
      />

      <Flex className="flex-col gap-4 p-5">
        {isAuthenticated ? <NWSDiscountCardUnlocked /> : <NWSDiscountCardLocked />}
      </Flex>
    </section>
  );
};

export default memo(NWSDiscountCard);
